(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/route-my-bets-wager-fallback.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/route-my-bets-wager-fallback.js');
"use strict";

const _svs$components$lbUi = svs.components.lbUi,
  SkeletonLine = _svs$components$lbUi.SkeletonLine,
  SkeletonCircle = _svs$components$lbUi.SkeletonCircle;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const WagerSkeleton = svs.components.tipsen.modularBase.WagerSkeleton;
const RouteWagerCouponFallback = _ref => {
  let isWideScreen = _ref.isWideScreen;
  return isWideScreen ? React.createElement("div", {
    className: "coupon-match-skeleton"
  }, React.createElement(SkeletonCircle, {
    className: "coupon-match-number-skeleton",
    size: 36
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-sign-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-sign-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-sign-skeleton"
  })) : React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid__coupon__mobile"
  }, React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__coupon__mobile__text"
  }));
};
const RouteMyBetsWagerFallback = () => {
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  return React.createElement(WagerSkeleton, null, React.createElement(WagerSkeleton.DrawCard, null), React.createElement(WagerSkeleton.Coupon, null, React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid__coupon__grid"
  }, Array.from({
    length: 13
  }).map((_, i) => {
    const key = "coupon-".concat(i);
    return React.createElement(RouteWagerCouponFallback, {
      isWideScreen: isWideScreen,
      key: key
    });
  }))), React.createElement(WagerSkeleton.SideNav, null), React.createElement(WagerSkeleton.ResultCard, null), React.createElement(WagerSkeleton.WinGroups, null), React.createElement(WagerSkeleton.Receipt, null), React.createElement(WagerSkeleton.Buttons, null));
};
setGlobal('svs.components.tipsen.modularBase.RouteMyBetsWagerFallback', RouteMyBetsWagerFallback);

 })(window);